

















































































































import Vue from 'vue'
// @ts-ignore
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import moment from 'moment'


interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  valid: boolean
  nullableDateRules: Array<Function>
  inSaveProgress: boolean

  vonDatum: string | null
  vonDatumFormatted: string | null
  bisDatum: string | null
  bisDatumFormatted: string | null
  menu1: boolean
  menu2: boolean

  artRadioGroup: any | null
  stufeRadioGroup: any | null

  gridData: any[]
}

export default Vue.extend({
  name: 'ProductBlocking',

  components: {
    NumberField,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    productId: Number,
    selectedProductUnitId: Number,
    selectedLagerungenId: Number,
    storageMetaData: Object as () => any,
    storageData: Object as () => any,
    isCreate: Boolean,
    isUpdate: Boolean,
    loading: Boolean
  },

  data (): ComponentData {
    //const required = (value: any): boolean | string => !!value || ''

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      valid: true,
      nullableDateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        }
      ],
      inSaveProgress: false,

      vonDatum: null,
      vonDatumFormatted: '',
      bisDatum: null,
      bisDatumFormatted: '',
      menu1: false,
      menu2: false,

      artRadioGroup: null,
      stufeRadioGroup: null,

      gridData: []
    }
  },

  watch: {
    isCreate (newVal: boolean): void {
      if(newVal) {
        this.resetData()
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    isUpdate (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    storageData (newVal: any): void {
      if(newVal) {
        this.setData()
      }
    },

  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isReadonlyFields (): boolean {
      if(this.isCreate || this.isUpdate) {
        return false
      } else {
        return true
      }
    }
  },

  methods: {
    artToggleRadio (value: any): void {
      if(this.artRadioGroup === value) {
        setTimeout(() => {
          this.artRadioGroup = null
        },0)
      } else {
        this.artRadioGroup = value
      }
    },

    stufeToggleRadio (value: any): void {
      if(this.stufeRadioGroup === value) {
        setTimeout(() => {
          this.stufeRadioGroup = null
        },0)
      } else {
        this.stufeRadioGroup = value
      }
    },

    onBlurVonDatum (): void {
      this.vonDatumFormatted = this.vonDatum && moment(this.vonDatum).isValid() ? moment(this.vonDatum).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onVonDatumChange (date: string): void {
      if(date && date.length > 0) {
        this.vonDatumFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.vonDatumFormatted = null
      }
    },

    onBlurBisDatum (): void {
      this.bisDatumFormatted = this.bisDatum && moment(this.bisDatum).isValid() ? moment(this.bisDatum).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onBisDatumChange (date: string): void {
      if(date && date.length > 0) {
        this.bisDatumFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.bisDatumFormatted = null
      }
    },

    onRowClick (): void {

    },

    onCancelClick (): void {
      this.setData()
      this.$emit('onCancelClick')
    },

    setData (): void {

    },

    resetData (): void {

    }
  },

  mounted () {
    this.setData()
  }

})
